<script>
import FavoriteTool from '../lib/favorite-tool.vue'

export default {
    emits: ['show-category-filter', 'search', 'delete-search'],
    components: {FavoriteTool},
    props: {
        filter: {type: Object, required: true},
        nodes: {type: Array, required: true},
        favKey: {type: String, required: true},
    },
    data() {
        return {
            search: this.filter.search,
            togglerCollapsed: true,
        }
    },
    computed: {
        favActive() {
            return this.filter.hasOwnProperty('favorites')
        }
    },
    methods: {
        onSearchInput() {
            if (this.search === '') this.$emit('delete-search')
        },
        onFilterNode(node) {
            this.togglerCollapsed = true
            this.$emit('on-filter-node', node)
        }
    },
}
</script>

<template>
<nav class="navbar navbar-expand-lg justify-content-between bg-info px-3">
  <button class="navbar-toggler btn navbar-btn btn-sm btn-secondary p-1 mb-1 me-1"
   type="button" @click.prevent="togglerCollapsed=!togglerCollapsed">
    <span class="fas fa-filter text-white"></span>
  </button>
  <favorite-tool :active="favActive" @click="$emit('toggle-favorites', !favActive)" />
  <div class="ml-auto">
    <form class="form-inline">
        <div class="d-flex flex-nowrap">
        <input class="form-control me-sm-2" type="search" placeholder="Quick Search" v-model="search"
         v-on:keyup.enter="$emit('search', search)" @input="onSearchInput()">
        <button class="btn btn-secondary" @click.prevent="$emit('search', search)">
            <span class="fa fa-search"></span>
        </button>
        </div>
    </form>
  </div>

  <div class="c-node-drawer fade-in" v-if="!togglerCollapsed">
      <a href="#" class="btn btn-outline float-end" @click.prevent="togglerCollapsed=true">
        <i class="fas fa-times"></i>
      </a>
      <ul class="nav bg-light flex-column pt-5">
        <li class="nav-item" v-for="node in nodes" :key="node.id">
          <a class="nav-link" href="#" @click.prevent="onFilterNode(node)">{{ node.name }}</a>
        </li>
      </ul>
  </div>

</nav>
</template>

<style scoped>
.c-node-drawer {
    position: fixed;
    height: 100%;
    width: 80%;
    top: 0;
    left: 0;
    background-color: whitesmoke;
    z-index: 9999;
}

.c-node-drawer.fade-in {
    display: block;
    animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

.nav-link {
    text-decoration: none;
}
</style>